import { Box, Skeleton } from "@chakra-ui/react";
import { Card } from "@src/components/ui-kit";
import { NavigationClient } from "@src/components/widgets/AppSubNav";

type PageLoadingProps = {
  clientId: string;
};

export const PageLoading = ({ clientId }: PageLoadingProps) => {
  return (
    <Card>
      <Box px="4">
        <NavigationClient id={clientId} variant="page" />
      </Box>
      <Skeleton minH="50dvh" roundedBottom="xl" />
    </Card>
  );
};
